import { render, staticRenderFns } from "./IconSpouse.vue?vue&type=template&id=9d9a7036&"
import script from "./IconSpouse.vue?vue&type=script&lang=ts&"
export * from "./IconSpouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports